__turbopack_context__.v({
  "content": "native-presentation-module__QeBw7a__content",
  "foundation": "native-presentation-module__QeBw7a__foundation",
  "theme": "native-presentation-module__QeBw7a__theme",
});
